/* eslint-disable */
import { useContext, useState } from 'react';
import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@material-ui/core';
import P, { shape } from 'prop-types';
import ConfirmationDialog from '../ConfirmationDialog';
import { MainContext } from '../../context/ApiContext';
import UserForm from '../UserForm';
import { MaskedTextField } from '../FormFields';

const IndicationManagerReportTableList = ({ listItem, title, states, sold, status }) => {
  const {
    deleters: { deleteUser },
  } = useContext(MainContext);
  const [open, setOpen] = useState(false);
  const [openConfirm, setOpenConfirm] = useState(false);
  const [user, setUser] = useState(null);
  const [id, setId] = useState('');
  const [dialog, setDialog] = useState({
    msg: '',
    title: '',
  });

  return (
    <>
      <ConfirmationDialog
        open={openConfirm}
        setOpen={setOpenConfirm}
        msg={dialog.msg.length > 0 ? dialog.msg : 'Dialog'}
        title={dialog.title.length > 0 ? dialog.title : 'Dialog'}
      />
      <UserForm open={open} setOpen={setOpen} title={title} user={user} />
      <TableContainer component={Paper}>
        <Table aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell>ID</TableCell>
              <TableCell>Nome do Cliente</TableCell>
              <TableCell>Veículo</TableCell>
              <TableCell>Data Indicação</TableCell>
              <TableCell>Data Captura</TableCell>
              <TableCell>Capturado em 3h</TableCell>
              <TableCell>Data Atendimento</TableCell>
              <TableCell>Finalizados em 24h</TableCell>
              <TableCell>Fase</TableCell>
              <TableCell>Status</TableCell>
              <TableCell>Corretor</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {listItem?.map((item) => (
              <TableRow key={item?.id}>
                <TableCell align="left">{item?.id}</TableCell>
                <TableCell>{item?.client_name || '-'}</TableCell>
                <TableCell>{item?.product || '-'}</TableCell>
                <TableCell>{item?.create_lead_date || '-'}</TableCell>
                <TableCell>{item?.capture_date || '-'}</TableCell>
                <TableCell>{item?.capture_on_time || '-'}</TableCell>
                <TableCell>{item?.end_lead_date || '-'}</TableCell>
                <TableCell>{item?.attendance_on_time || '-'}</TableCell>
                <TableCell>{item?.state || '-'}</TableCell>
                <TableCell>{item?.status || '-'}</TableCell>
                <TableCell>{item?.broker_name || '-'}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};

IndicationManagerReportTableList.propTypes = {
  listItem: P.arrayOf(
    shape({
      id: P.number,
      name: P.string,
    })
  ),
  title: P.string.isRequired,
};

IndicationManagerReportTableList.defaultProps = {
  listItem: null,
};

export default IndicationManagerReportTableList;
